import * as Yup from 'yup';

export const TripLogSchema = Yup.object().shape({
    driverId: Yup.string().required('Driver Name is required'),
    dateOfTrip: Yup.date().required('Date of trip is required').typeError('Please select a valid date'),
    customerEmail: Yup.array().of(Yup.string().email('Please enter a valid email')).min(1, 'At least one email is required').required('Email is required'),
});

export type TripLogDataType = Yup.InferType<typeof TripLogSchema>;

type InitialValues = {
    driverId: string;
    dateOfTrip: string;
    customerEmail: string[];
};

export const TripLogInitialValues: InitialValues = {
    driverId: '',
    dateOfTrip: '',
    customerEmail: [],
};

export interface TripLogInterface {
    driverId: string;
    dateOfTrip: string;
    customerEmail: string[];
}
